(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('teoriprove', {
            parent: 'app',
            url: '/teoriprøve?type&subject',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/teoriprove/teoriprove.html',
                    controller: 'TeoriproveController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('teoriprove-result', {
            parent: 'app',
            url: '/teoriprøve/:sessionId/result',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/teoriprove/teoriprove-result.html',
                    controller: 'TeoriproveResultController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
